import React, { Component } from 'react'
import poo from "../../src/img/poo.jpg"
import { Paper,Box,Link, AppBar } from '@mui/material';
import { Container,Typography,Card,Grid,Divider,TextField,Button} from '@mui/material';



const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/" sx={{fontSize:14,color:'#c7167a',}}>
      Home
    </Link>,
   
    <Typography key="3" color="text.primary" sx={{fontSize:14,color:'#c7167a'}}>
    career
    </Typography>,
  ];

export class About extends Component {
  render() {
    return (
      <div>
      
      <br/>
      <br/>
      <Box sx={{backgroundImage:{xs:`url(${poo})`,sm:`url(${poo})`},width:'100%',display:'flex',height:{xs:200,sm:250,md:310},backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',}}>
      <br/>
      <br/>
      <Box sx={{paddingLeft:{xs:0,sm:3},paddingRight:{xs:0,sm:3},mt:3,width:'100%'}}>
      <Container maxWidth='xl'>
      <Box sx={{background:'rgba(28,68,106,.7)',height:{xs:140,sm:180,md:200}, width:'100%',mt:1,}}>
      <Box sx={{mt:2}}>
      <br/>
       <Typography align='center' sx={{color:'#fff',fontWeight:'900',fontSize:{xs:17,sm:17,md:21},fontFamily:'inherit'}}>ABOUT THE VENDOR</Typography>
       <Typography align='center' sx={{color:'#fff',fontWeight:'900',fontSize:{xs:17,sm:17,md:21},fontFamily:'inherit'}}>FINDING PORTAL</Typography>
      </Box>


      <Box sx={{display:'flex',justifyContent:'center',mt:{xs:2,sm:2,md:5}}}>
      <Box sx={{backgroundColor:'#c7167a',height:40,width:150,borderRadius:10,}}>
<Box sx={{display:'flex',justifyContent:'center'}} >
<Box>
<Typography sx={{mt:1,color:'white'}}>Learn</Typography>
</Box>
</Box>
      </Box>
      </Box>
      </Box>
      </Container>
      </Box> 
 </Box>




 <Box sx={{minHeight:300,backgroundColor:'#e8eeee ',opacity:0.9,backgroundRepeat:''}}>
 <Box sx={{paddingLeft:{xs:0,sm:3},paddingRight:{xs:0,sm:3}}}>
  <Container maxWidth='xl'>
  <br/>
 <Box sx={{mt:1,mb:1,minHeight:300,}}>
 
 <Grid container spacing={2}>
  <Grid item  size={{xs:12,sm:12,md:6}} >
  <Box sx={{display:'flex',flexDirection:'column'}}>
  <br/>
  <Typography variant='h1'  sx={{fontSize:{xs:25,sm:25,md:34},fontWeight:'800',fontFamily:'sans-serif'}}>We didn't find it for us,</Typography>
  <Typography variant='h1'  sx={{fontSize:{xs:25,sm:25,md:34},fontWeight:'800',mt:1,fontFamily:'sans-serif',color:'#c7167a '}}>so we created it for you</Typography>
  <br/>
  <Typography align='justify' sx={{mb:2,mr:{xs:'0',sm:'0',md:'10%',},fontWeight:'335',fontFamily: 'Roboto Slab',color:'black',fontSize:{xs:13,sm:13,md:17,lg:17},lineHeight:2}}>this Vendor Panel is a secure, user-friendly dashboard that enables vendors or sellers to efficiently manage their products, orders, customers, inventory, and business operations from a single platform. It is designed to streamline the selling process while providing real-time insights into business performance.</Typography>
  </Box>
  
  </Grid>
  <Grid item  size={{xs:12,sm:12,md:6}} >

  <Box sx={{m:{xs:'0',sm:'0',md:'2'}}}>
  <Box sx={{borderRadius:10,height:370,}}>
  <Box
     component="img"
     sx={{
       height:370,
       display: 'block',
     objectFit:'cover',
       overflow: 'hidden',
       width:'100%',
       borderRadius:2
     }}
    src={poo}
     alt=''
   />
  </Box>
  </Box>



    
  </Grid>
</Grid>
 </Box>
 <br/>
 </Container>
</Box>
 </Box>

      
      </div>
    )
  }
}

export default About








